<div class="modal-header" bsModal [ngClass]="{'bg-primary': type === 0, 'bg-success' : type === 1, 'bg-info' : type === 2,
  'bg-warning' :
  type === 3, 'bg-danger' : type === 4}">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <button pRipple type="button" class="btn-close pull-right" aria-label="btn-close" (click)="closeModal('Cancel')">
  </button>
</div>
<div class="modal-body" [innerHTML]="message">
</div>
<div class="modal-footer" appModalFocus>
    <ng-container *ngFor="let btnOption of btnOptions; let i = index">
        <ng-container [ngSwitch]="i">
            <button pRipple type="button" *ngSwitchCase="0" class="btn btn-sm btn-primary" appFocus (click)="closeModal(btnOption)">{{btnOption}}</button>
            <button pRipple type="button" *ngSwitchDefault class="btn btn-sm" (click)="closeModal(btnOption)" [ngClass]="(i === 1 && btnOptions.length > 2) ? 'btn-primary' : 'btn-secondary'">{{btnOption}}</button>
        </ng-container>
    </ng-container>
</div>